import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b57de34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "menu mobile"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-name" }, " 주식회사 다이노스밴드 ", -1))
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "menu__copy" }, " © Copyright 2021 Dinosband Inc. All rights reserved ", -1))
const _hoisted_6 = {
  key: 0,
  class: "menu__tos"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.screenInfo.isPlatform === 'mobile')
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _createElementVNode("li", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/policy')))
          }, " 개인정보 처리방침 ")
        ]))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.screenInfo.isPlatform === 'desktop')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/policy')))
            }, " 개인정보 처리방침 ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}